import { IAutomationAppComponent, IAutomationObject } from "../../types";
import { RoomIcon } from "./IconRoom";
import { schema } from "./types";
import { OverviewPanel, OperatorPanel, ConfigurationPanel } from '.';
import { ParameterPanel } from "./ParameterPanel";
import { schemaTemperature, schemaHumidity } from '../../Devices/SensorAnalog/types'
import { schemaFan } from '../../Devices/DriveVarSpeed/types'
import { schema as schemaValveVar } from '../../Devices/ValveVar/types'
import { schema as schemaLight } from '../../Devices/Light/types'
import { schema as schemaMultistate } from '../../Devices/MultiState'
import { schema as schemaMultistateSwitch } from '../../Devices/MultiStateSwitch'
import { SideviewPanel } from "./SideviewPanel";
import InsightsPanel from "./InsightsPanel";

export const App: IAutomationAppComponent = {
    schema: schema,
    supportsProcessPanel: true,
    Icon: RoomIcon,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel,
    ConfigurationPanel: ConfigurationPanel,
    ParameterPanel: ParameterPanel,
    SideViewPanel: SideviewPanel,
    InsightsPanel: InsightsPanel,
    createConfig: {
        group: 'Spaces',
        name: "Room",
        description: "Room",
        panel: OverviewPanel,
        defaultState: {},
    },
    addAppFilter: (app: IAutomationObject) =>
        app.schema === schemaTemperature ||
        app.schema === schemaHumidity ||
        app.schema === schemaFan ||
        app.schema === schemaValveVar ||
        app.schema === schemaLight ||
        app.schema === schemaMultistate ||
        app.schema === schemaMultistateSwitch
}